export default "__VITE_ASSET__DiT$dlxN__"